import React, { CSSProperties } from 'react'

import './LabelComponent.scss'

interface ILabelComponentProps extends CSSProperties {
    className?: string
    style?: CSSProperties
    children?: any
    onClick?: () => void
    id?: string,
}

const LabelComponent: React.FC<ILabelComponentProps> = ({
  className,
  style,
  children,
  onClick,
  id,
  ...overrideStyles
}) => {
  return(
    <p
      className={`label_component-layout ${className ? className : ''}`}
      style={{
        ...overrideStyles,
        ...style,
      }}
      onClick={onClick}
      id={id}
    >
      {children}
    </p>
  );
}

export default LabelComponent;
